import UIComponent from "sap/ui/core/UIComponent";
import RouteServices from "niteroi/services/RouteServices";

/**
 * Installer Component
 *
 * @namespace niteroi.packages.installer
 */
export default class Component extends UIComponent {
    private _routeServices: RouteServices | undefined;
    public static metadata = {
        interfaces: ["sap.ui.core.IAsyncContentCreation"],
        manifest: "json"
    };

    public init(): void {
        super.init();
        if (this.getRouter().isInitialized() === false) {
            this._routeServices = new RouteServices(this);
        }
    }

    public getRouteServices(): RouteServices | undefined {
        return this._routeServices;
    }
}
